import React from 'react';

const ARTIST_ID = '06HXnS61xDNUfn9B1pATdM';

interface SpotifyEmbedProps {
  height?: number;
}

const SpotifyEmbed: React.FC<SpotifyEmbedProps> = ({ height = 380 }) => (
  <iframe
    title="Smuglergods på Spotify"
    src={`https://open.spotify.com/embed/artist/${ARTIST_ID}?utm_source=generator&theme=0`}
    width="100%"
    height={height}
    style={{ border: 'none', borderRadius: 10 }}
    allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
    loading="lazy"
  />
);

export default SpotifyEmbed;
